import type { ApiErrorBody } from '@nexo/types';

export class ApiError extends Error {
  readonly status: number;
  readonly issues: Record<string, string[]> | undefined;
  /** The whole error body, for errors that carry extra details. */
  readonly body: unknown;

  constructor(status: number, body: unknown) {
    const parsed = (typeof body === 'object' && body !== null ? body : {}) as Partial<ApiErrorBody>;
    super(
      typeof parsed.message === 'string' ? parsed.message : `Request failed with status ${status}`,
    );
    this.name = 'ApiError';
    this.status = status;
    this.issues = parsed.issues;
    this.body = body;
  }
}

/** Human-readable message for any error thrown by the client. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof TypeError) return 'No se pudo conectar con el servidor';
  if (error instanceof Error) return error.message;
  return 'Error inesperado';
}
